export default function Testimonial() {
  return (
    <section
      data-testid="testimonial-section"
      className="relative py-24 md:py-40 overflow-hidden"
      style={{ backgroundColor: "#15243D" }}
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-25"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1503891617560-5b8c2e28cbf6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxwZWFjZWZ1bCUyMG5hdHVyZSUyMG1pbmltYWxpc20lMjB3YXRlcnxlbnwwfHx8fDE3ODA4NDA4NTF8MA&ixlib=rb-4.1.0&q=85')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-[#15243D]/70" />

      <div className="relative max-w-5xl mx-auto px-6 md:px-12 text-center md:text-left">
        <p
          className="overline mb-10"
          style={{ color: "#C07865" }}
        >
          What others have said
        </p>
        <blockquote
          className="serif text-3xl sm:text-4xl md:text-5xl text-[#F7F5F0] leading-[1.2] tracking-tight max-w-4xl"
          style={{ fontWeight: 300 }}
          data-testid="testimonial-quote"
        >
          “I came in looking for a strategy. I left with something quieter and
          more lasting — a way of meeting my own life. The work is small. The
          shift is enormous.”
        </blockquote>
        <p className="mt-10 text-sm tracking-[0.2em] uppercase text-[#8A8D93]">
          — M. R., Anchor client, 2024
        </p>
      </div>
    </section>
  );
}
